import { Component, ViewChild, ViewChildren } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import {each} from 'lodash';
@Component({
    selector: 'unwanted-cvpcbutton',
    styles: [`
        :host{
        }
        .accordian-card{
            margin:0;
            margin-bottom:10px;
        }
        .img-size{
          height: 70px;
          width: 70px;
        }
        .selected{
          border: 2px solid #007382;
          text-align: center;
          border-radius: 6px;
        }
        .cvpc_text{
          text-align: center;
          color: #4D4D4F;
          word-wrap: break-word;
          line-height: 1.5em;
          overflow: hidden;
          white-space: break-spaces;
          text-overflow: ellipsis;
          width: 100%;
        }
        .container{
          text-align:center;
        }
        .my_cvpc_btn_container_old{
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
          height: 150px;
        }
        .my_cvpc_btn_container{
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
          overflow-x: auto;
        }
        .imgsize{
          width:67px;
          height:60px;
        }
        .my_cvpc_btn_container input {
          width: 100%;
          height: 100%;
          position: absolute;
          opacity: 0;
        }
        .scroll_xy{
          overflow: auto;
          background: #EDF5F5;
        }
        .cat_box{
          width: 100px;
          position: relative;
          float: left;
          flex: 0 0 auto;
          margin:5px;
        }
        .cat_box:last-child {
          margin-right:50px;
        }
        .titletext{
          padding: 10px 0;
        }
        .subtitletext{
          color: #6b6b6b;
        }
        .bottomtext{
          color: #000;
          margin-top: 20px;
        }
        .title-text{
          display: flex;
          flex-direction: column;
        }
        `
    ],
    template: `<div *ngIf="to.myoption" style="display:flex;flex-direction:column" >
            <ion-row *ngIf="to.title" class="title-text">
                <ion-label class="titletext"> {{to.title | translate}} </ion-label>
                <ion-label class="subtitletext" *ngIf="to.subtitle"> {{to.subtitle | translate}} </ion-label>
               
              </ion-row> 
              <div >
                <div class="my_cvpc_btn_container"  >
                  <div #contenti *ngFor="let option of to.myoption; let i = index" class="cat_box" (change)="onChange(option)">
                  <input type="radio" 
                  [name]="'critical_vpc_type'"
                  [formControl]="formControl" 
                  [checked]="option.value == formControl.value"
                  [formlyAttributes]="field"
                  [value]="option.value"
                  id="{{option.label | translate}}">
                  <div  *ngIf="formControl.value != option.value" class="container" >
                    <img class="imgsize"  [src]="option.disable_url"/>
                    <div class="cvpc_text">
                      {{option.label | translate}}
                    </div>
                  </div>
                  <div  class="selected"  *ngIf="formControl.value == option.value">
                    <img class="imgsize" [src]="option.url"/>
                    <div class="cvpc_text">
                      {{option.label | translate}}
                    </div>
                  </div>
              </div>
            </div>  
            </div>
            <ion-row >
            <ion-label class="bottomtext" *ngIf="formControl.value != null"> Questionnaire </ion-label>
              </ion-row> 
            </div>  
    `,
    standalone: false
})

export class CvpcRadioButtonFormlyType extends FieldType {
  isSelected: any;
  @ViewChildren('contenti') contenti: any;
  constructor() {
    super();
  }

  ngOnInit() {
    console.log("content",this.contenti);
    // this.contenti.nativeElement.focus();
  }

  ngAfterViewInit() {
    let optionindex: number = 0;
    each(this.to.myoption, (op: any, index: number) => {
      if(op.value == this.formControl.value){
        optionindex = index
      }
    });
    const allElem = this.contenti.toArray();
    allElem[optionindex].nativeElement.scrollIntoView(false);
  }
  onChange(option: any) {
    console.log("check=",option);
    this.to.myoption.forEach(element => {
      if(element.value==option.value){
        element.check=true;
      }else{
        element.check=false;
      }
    });
  }

}